module.exports = __webpack_public_path__ + "img/Skittles.db40ff0c.webp";